import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { contabilidadService } from '../services/contabilidadService';
import type { CategoriaMovimiento, CreateCategoriaPayload } from '../types';

export const CATEGORIAS_QUERY_KEY = ['contabilidad', 'categorias'] as const;

export function useCategorias(tipo?: 'Ingreso' | 'Egreso') {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery<CategoriaMovimiento[]>({
    queryKey: [...CATEGORIAS_QUERY_KEY, tipo],
    queryFn: () => contabilidadService.listCategorias(tipo),
    staleTime: 1000 * 60,
  });

  const createMutation = useMutation({
    mutationFn: (payload: CreateCategoriaPayload) =>
      contabilidadService.createCategoria(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATEGORIAS_QUERY_KEY });
    },
  });

  return {
    categorias: data ?? [],
    isLoading,
    error,
    createCategoria: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
  };
}
